export const en = {
    "apk-title": "APK",
    "apk-description": "Upload the application in .apk format",
    "version-name-title": "Version Name",
    "version-name-description": "in a free format, e.g., 28.6.1.TV-yandex. It will be displayed in the app store",
    "version-title": "Application Version",
    "min-sdk-version-title": "Minimum SDK Version",
    "apk-title-with-group": "APK for devices with Android version equal to or higher than {androidGroup}",
    "apk-android-group-already-used": "An apk for Android version {androidGroup} and higher has already been uploaded.",
    "add-apk-title": "Additional APK",
    "add-apk-description": "You can add another APK to have different APKs for various distribution platforms. Add a comment so that the developer knows which platforms to upload the new APK to.",
    "add-apk-action": "Add APK",
    "delete-apk-title": "Remove APK and all related fields",
    "delete-apk-action": "Delete",
    "apk-packages-names-should-be-the-same": "Package names must match.",
    "download": "Download",
} as const;

export const ru = {
    "apk-title": "APK",
    "apk-description": "Загрузите приложение в формате .apk",
    "version-name-title": "Название версии",
    "version-name-description": "в свободном формате, например 28.6.1.TV-yandex. Оно будет отображаться в магазине приложений",
    "version-title": "Версия приложения",
    "min-sdk-version-title": "Минимальная версия SDK",
    "apk-title-with-group": "APK для устройств с версией андройда {androidGroup} или выше",
    "apk-android-group-already-used": "Уже загружен apk для версии андройда {androidGroup} и выше.",
    "add-apk-title": "Дополнительная APK",
    "add-apk-description": "Вы можете добавить ещё одну APK, чтобы иметь разные APK для различных платформ распространения. Добавьте комментарий, чтобы разработчик знал, для каких платформ загружать новую APK.",
    "add-apk-action": "Добавить APK",
    "delete-apk-title": "Удалить APK и все поля связанные с ней",
    "delete-apk-action": "Удалить",
    "apk-packages-names-should-be-the-same": "Имена пакетов должны совпадать.",
    "download": "Скачать",
} as const;
